




















import Vue from 'vue';
import Component from 'vue-class-component';
import SectionLayout from '../SectionLayout.vue';
import {TimelineMax} from 'gsap';

@Component({
  components: {
    SectionLayout,
  },
})
export default class HomeLivesImpacted extends Vue {
  counters: Array<number> = [0, 0, 0];
  counterTargets: Array<number> = [452, 367, 890];

  animate(direction: string) {
    const startCount = [0, 0, 0];
    const tl = new TimelineMax({onUpdate: update.bind(this)})
      .to(startCount, 4, {0: this.counterTargets[0]}, 0)
      .to(startCount, 3, {1: this.counterTargets[1]}, 0)
      .to(startCount, 2, {2: this.counterTargets[2]}, 0);

    function update() {
      // @ts-ignore
      this.counters = startCount.map((x) => (
        `00000${Math.round(x)}`.substr(-3)
      ))
    }
  }
}

